/**
 * Returns the effective address for an estimate.
 * If the estimate has a leadAddress (alternate address), use it.
 * Otherwise, fall back to the lead's main address.
 */
export function getEstimateAddress(estimate) {
  if (estimate.leadAddress) {
    return estimate.leadAddress;
  }
  return {
    street: estimate.Lead?.street,
    city: estimate.Lead?.city,
    state: estimate.Lead?.state,
    zipcode: estimate.Lead?.zipcode,
    latitude: estimate.Lead?.latitude,
    longitude: estimate.Lead?.longitude,
  };
}

/**
 * Format an address object to a single-line string.
 */
export function formatAddress(addr) {
  if (!addr) return '';
  return [addr.street, addr.city, addr.state, addr.zipcode].filter(Boolean).join(', ');
}
